export default __webpack_public_path__ + "static/media/hh4.537440c6.png";